import { type InferOutput, number, object, optional, string } from 'valibot'

import { createSorterSchema, SITES_SORT_KEYS } from '@/features/shared/models'

export const SitesSearchSchema = object({
  page: optional(number()),
  take: optional(number()),
  ...createSorterSchema(SITES_SORT_KEYS),
  dcId: optional(number()),
  name: optional(string()), // 地点名
  code: optional(string()), // 地点コード
  siteImportJobId: optional(number()) // 取込ジョブID
})

export type SitesSearch = InferOutput<typeof SitesSearchSchema>
